<script lang="ts">
	//Design system components
	import { Button, Input, toast } from '@Shelly/shelly-design-system';

	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Storers
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';

	export let device;

	const id = real_id(device.id);
	let settings = readDeviceSettings(id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore ?? settings;
	let min = 1,
		max = 5,
		loading = false;

	let value = settings.fade_rate;
	let cache = value;
	let localIp = get_local_ip(id);

	const setBtnFade = async () => {
		if (cache !== value) {
			let res;
			loading = true;
			if (localIp) {
				res = await localReq(device, `${localIp}/settings/`, 'post', {
					fade_rate: value,
				});
			} else {
				res = await postReq(`/device/${device.category}/settings/fade_rate`, {
					id: id,
					rate: value,
					channel: device.channel,
				});
			}

			if (res.isok) {
				toast.open({
					type: 'success',
					title: $format('change_button_fade_scc_toast', {
						values: { value },
						default: `Buttons fade rate speed was changed to ${value}.`,
					}),
				});
				settings.fade_rate = value;
				devices_settings.update_devices_settings(device.id, settings);
				cache = value;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Input
	class="mb-s"
	type="number"
	{min}
	{max}
	info={$format('change_fade_button_value_description', {
		values: { min, max },
		default: 'Buttons fade rate speed from {min}x to {max}x:',
	})}
	size="m"
	bind:value
	on:enter={setBtnFade}
	id="input-iqkcs57"
	aria-label={$format('change_fade_button_value_description', {
		values: { min, max },
		default: 'Buttons fade rate speed from {min}x to {max}x:',
	})}
/>

<Button class="mt-s" {loading} size="m" width="full" on:click={setBtnFade}
	>{$format('button_save')}</Button
>
